import { render, staticRenderFns } from "./DomainSettings.vue?vue&type=template&id=450ba76d&scoped=true"
import script from "./DomainSettings.vue?vue&type=script&lang=js"
export * from "./DomainSettings.vue?vue&type=script&lang=js"
import style0 from "./DomainSettings.vue?vue&type=style&index=0&id=450ba76d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450ba76d",
  null
  
)

export default component.exports